import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WebbtreeVerifiedService } from "../_services/webbtree-verified.service";
import { CandidateService } from "../_services/candidate.service";
import { SearchtoolboxService } from "../_services/searchtoolbox.service";
import { Router } from "@angular/router";
import { LocalStorageService } from "../_services/local-storage.service";
import { DomSanitizer } from "@angular/platform-browser";
import { TransactionService } from "../_services/transaction.service";
import { PersonSearchService } from "../_services/person-search.service";
import * as moment from "moment";
import { GlobalService } from "../_services/global.service";
import { Observable, Subject } from "rxjs";
import { CustomValidator } from "../_services/customValidator";
declare const clevertap;
@Component({
  selector: "app-add-edit-experience-modal",
  templateUrl: "./add-edit-experience-modal.component.html",
  styleUrls: ["./add-edit-experience-modal.component.scss"],
})
export class AddEditExperienceModalComponent implements OnInit {
  experience_form: FormGroup;
  experience: any;
  moment = moment;
  year_list = GlobalService.yearList();
  months = GlobalService.months
  iscurrent: any = 0;

  @Input() experienceDetails: any;
  basicdetails: any;
  educationid: any;
  experienceOldOBj: any;
  successMessage: string;
  errorMessage: string;
  showExperienceDetails: boolean;
  joblist: any;
  autocomplete_company: boolean = true;
  companylist: any;
  locationlist: any;
  @Input() candidateid: any;
  @Input() experienceid: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() refreshCandidateListEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    public requestContract: WebbtreeVerifiedService,
    public modalService: NgbModal,
    private fb: FormBuilder,
    public candidateservice: CandidateService,
    private searchtoolbox: SearchtoolboxService,
    public router: Router,
    private _localstorageservice: LocalStorageService,
    private transactionservice: TransactionService,
    private sanitization: DomSanitizer,
    private personSearchService: PersonSearchService
  ) {}

  ngOnInit(): void {
    this.experience_form = this.fb.group({
      jobtitle: [
        this.experienceDetails ? this.experienceDetails.jobtitle : "",
        [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      ],
      companyname: [
        this.experienceDetails ? this.experienceDetails.companyname : "",
        [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      ],
      worklocation: [
        this.experienceDetails ? this.experienceDetails.locationname : "",
        [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      ],
      currentyear: [
        this.experienceDetails ? this.experienceDetails.iscurrent : "",
      ],
      workdescription: [
        this.experienceDetails ? this.experienceDetails.workdescription : "",
        Validators.pattern(/^(?!.*<[^>]+>).*/i),
      ],

      startdate: this.fb.group({
        year: [this.experienceDetails ?  this.experienceDetails.startdate.split('-')[0] : null,Validators.required],
        month: [this.experienceDetails  != null ? this.experienceDetails.startdate.split('-')[1] : null,Validators.required,]
    }),
      enddate: this.fb.group({
        year: [this.experienceDetails && this.experienceDetails.enddate ?  this.experienceDetails.enddate.split('-')[0]  : null],
        month: [ this.experienceDetails  != null && this.experienceDetails.enddate ? this.experienceDetails.enddate.split('-')[1]  : null]
      }),
    },  {validators: CustomValidator.DateValidation});

    this.iscurrent = this.experienceDetails? this.experienceDetails.iscurrent :0;
    this.experienceOldOBj = this.experienceDetails;

    //Set Error for (if end year > start year)
    this.experience_form.controls["enddate"].valueChanges.subscribe(
      (changes) => {
        if (
          this.experience_form.get("startdate").value >
            this.experience_form.get("enddate").value &&
          this.experience_form.get("enddate").value != null
        ) {
          return this.experience_form["controls"].enddate.setErrors({
            incorretexperience: true,
          });
        } else {
          return this.experience_form["controls"].enddate.setErrors(null);
        }
      }
    );

    if(this.iscurrent != 1) {
      this.experience_form.controls["enddate"].get('year').setValidators([Validators.required]);
      this.experience_form.controls["enddate"].get('month').setValidators([Validators.required]);
      this.experience_form.controls["enddate"].get('year').updateValueAndValidity();
      this.experience_form.controls["enddate"].get('month').updateValueAndValidity();
    }
  }
  getautocompleteData(type, input): Observable<any> {
    let data = {
      dropdowntype: type,
      searchedstring: input,
    };
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res: any) => {
      if (res.status == "success") {
        subject.next(res.data);
      } else {
        subject.next([]);
      }
    });
    return subject.asObservable();
  }

  toastmessage(message, type) {
    if (type == "success") {
      this.successMessage = message;
      setTimeout(() => (this.successMessage = ""), 5000);
    } else if (type == "error") this.errorMessage = message;
    setTimeout(() => (this.errorMessage = ""), 5000);
  }
  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }
  currentlyWorkingChecked(event) {
    let isCurrentlyWorking = event.target.checked;
    if (isCurrentlyWorking) {
      this.iscurrent = 1;
      this.experience_form.patchValue({
        enddate: ({year: null, month:null}),
      });
      this.experience_form.controls["enddate"].get('year').clearValidators();
      this.experience_form.controls["enddate"].get('month').clearValidators();
      this.experience_form.controls["enddate"].get('year').updateValueAndValidity();
      this.experience_form.controls["enddate"].get('month').updateValueAndValidity();
    } else {
      this.iscurrent = 0;
      this.experience_form.patchValue({
        enddate: ({year: null, month:null}),
      });
      // this.experience_form.controls["endyear"].setValidators(
      //   Validators.required
      // );
      this.experience_form.controls["enddate"].get('year').setValidators(
        Validators.required
      );
      this.experience_form.controls["enddate"].get('month').setValidators(
        Validators.required
      );
      this.experience_form.controls["enddate"].get('year').updateValueAndValidity();
      this.experience_form.controls["enddate"].get('month').updateValueAndValidity();
      // this.experience_form.controls["endyear"].updateValueAndValidity();
    }
  }

  //Edit Experience Div
  EditExperienceDetails(experience: any) {
    this.experience_form = this.fb.group({
      jobtitle: [
        this.experienceDetails ? this.experienceDetails.jobtitle : "",
        [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      ],
      companyname: [
        this.experienceDetails ? this.experienceDetails.companyname : "",
        [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      ],
      worklocation: [
        this.experienceDetails ? this.experienceDetails.locationname : "",
        [Validators.required, Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      ],
      currentyear: [
        this.experienceDetails ? this.experienceDetails.iscurrent : "",
      ],
      // startyear: [
      //   this.experienceDetails
      //     ? moment(this.experienceDetails.startdate).format("YYYY")
      //     : null,
      //   Validators.required,
      // ],
      // endyear: [
      //   this.experienceDetails
      //     ? moment(this.experienceDetails.enddate).format("YYYY")
      //     : null,
      //   Validators.required,
      // ],
      workdescription: [
        this.experienceDetails ? this.experienceDetails.workdescription : "",
        Validators.pattern(/^(?!.*<[^>]+>).*/i),
      ],
      startdate: this.fb.group({
        year: [this.experienceDetails ?  this.experienceDetails.startdate.split('-')[0] : null,Validators.required],
        month: [this.experienceDetails  != null ? this.experienceDetails.startdate.split('-')[1] : null,Validators.required,]
    }),
      enddate: this.fb.group({
        year: [this.experienceDetails && this.experienceDetails.enddate ?  this.experienceDetails.enddate.split('-')[0]  : null,Validators.required,],
        month: [ this.experienceDetails  != null && this.experienceDetails.enddate ? this.experienceDetails.enddate.split('-')[1]  : null,Validators.required,]
      }),
    }, {validators: CustomValidator.DateValidation});

    this.experience_form.controls.workdescription.valueChanges.subscribe(
      (res: any) => {
        let scriptRegex = /&lt;script(.*)&gt;/g;
        let scriptRegex1 = /<script(.*)>/g;
        let htmltagscript = /<(.|\n)*?>/;
        if (
          res &&
          (scriptRegex.test(res.trim()) == true ||
            scriptRegex1.test(res.trim()) == true ||
            res.includes("src=") ||
            htmltagscript.test(res.trim()) == true)
        ) {
          this.experience_form
            .get("workdescription")
            .setErrors({ pattern: true });
        } else {
          this.experience_form.get("workdescription").setErrors(null);
        }
      }
    );

    
    if (this.iscurrent == 1) {
      this.experience_form.controls["endyear"].clearValidators();
      this.experience_form.controls["endyear"].updateValueAndValidity();
    }
  }

  //Add Experience Details
  addexperience() {
    let data = {};
    if (this.experience_form.valid) {
      data = {
        candidateexperienceid: this.experienceid ? this.experienceid : null,
        candidatenumber: this.candidateid,
        jobtitle: this.experience_form.value.jobtitle
          ? this.experience_form.value.jobtitle.replace(/'/g, "")
          : null,
        companyname: this.experience_form.value.companyname
          ? this.experience_form.value.companyname.replace(/'/g, "")
          : null,
        locationname: this.experience_form.value.worklocation
          ? this.experience_form.value.worklocation.replace(/'/g, "")
          : null,
        iscurrent: this.experience_form.value.currentyear,
        startdate: this.experience_form.value.startdate.year+"-"+this.experience_form.value.startdate.month,
        enddate: this.experience_form.value.enddate.year != null ? this.experience_form.value.enddate.year+"-"+this.experience_form.value.enddate.month: null,

        // startdate: moment(this.experience_form.value.startyear).format(
        //   "YYYY-MM-DD"
        // ),
        // enddate:
        //   this.experience_form.value.endyear != "Invalid date" &&
        //   this.experience_form.value.endyear != null
        //     ? moment(this.experience_form.value.endyear).format("YYYY-MM-DD")
        //     : null,
        workdescription: this.experience_form.value.workdescription
          ? this.experience_form.value.workdescription.replace(/'/g, "")
          : null,
        usernumber: this._localstorageservice.getItem("usernumber"),
      };
      if (!this.experienceid) {
        data["activitylog"] = [
          {
            action: "'create'",
            tablename: "'candidateexperience'",
            type: "'experience'",
            updatedfieldname: "'null'",
            oldvalue: "'null'",
            newvalue: "'null'",
          },
        ];
      } else if (this.experienceid) {
        if ("startdate" in this.experienceOldOBj) {
          this.experienceOldOBj["startdate"] =
            this.experienceOldOBj["startdate"] != "Invalid date"
              ? moment(this.experienceOldOBj.startdate).format("YYYY-MM-DD")
              : null;
        }
        if ("enddate" in this.experienceOldOBj) {
          this.experienceOldOBj["enddate"] =
            this.experienceOldOBj["enddate"] != "Invalid date"
              ? moment(this.experienceOldOBj.enddate).format("YYYY-MM-DD")
              : null;
        }

        let activity = [];
        let experienceOldOBj = {
          jobtitle: this.experienceOldOBj.jobtitle
            ? this.experienceOldOBj.jobtitle.replace(/'/g, "")
            : null,
          companyname: this.experienceOldOBj.companyname
            ? this.experienceOldOBj.companyname.replace(/'/g, "")
            : null,
          locationname: this.experienceOldOBj.locationname
            ? this.experienceOldOBj.locationname.replace(/'/g, "")
            : null,
          iscurrent: this.experienceOldOBj.iscurrent,
          startdate: this.experienceOldOBj.startdate,
          enddate: this.experienceOldOBj.enddate,
          workdescription: this.experienceOldOBj.workdescription
            ? this.experienceOldOBj.workdescription.replace(/'/g, "")
            : null,
        };

        let result = Object.keys(experienceOldOBj).filter(
          (k) => experienceOldOBj[k] !== data[k]
        );
        result.map((elem, index) => {
          activity.push({
            action: "'update'",
            tablename: "'candidateexperience'",
            type: "'experience'",
            updatedfieldname: "'" + elem + "'",
            oldvalue: "'" + experienceOldOBj[elem] + "'",
            newvalue: "'" + data[elem] + "'",
          });
        });
        if (activity.length > 0) {
          data["activitylog"] = activity;
        }
      }

      this.candidateservice
        .updateCandidateExperience(data)
        .subscribe((res: any) => {
          if (res.status == "success") {
            this.toastmessage("Experience Added Successfully", "success");
            // this.showAllDetail('details')
            this.candidateservice.createCandidateData();
            this.passEntry.emit("success");
            //- Clevertap Edit Profile event
            let ctObj = {
              Name:
                this.basicdetails.firstname + " " + this.basicdetails.lastname,
              "Job title": this.basicdetails.jobtitle,
              "Company Name": this.basicdetails.companyname,
              Source: this.basicdetails.source,
              Location: this.basicdetails.locationname,
              Origin: "Web app",
            };
            this.cleverTapEvent("Edit Profile", ctObj);
          } else {
            this.toastmessage("Something Went Wrong", "error");
            this.passEntry.emit("error");
          }
        });
    } else {
      this.validateAllFormFields(this.experience_form);
    }
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  //Typeahead for JobTitles
  searchJobs(e) {
    if (e.target.value != "" && e.target.value.length > 2) {
      this.getautocompleteData("job titles", e.target.value).subscribe(
        (res) => {
          this.joblist = res;
        }
      );
    } else {
      this.joblist = [];
    }
  }

  //Typeahead for CompanyName
  searchCompany(e) {
    if (
      e.target.value != "" &&
      e.target.value.length > 2 &&
      this.autocomplete_company
    ) {
      this.autocomplete_company = false;
      this.getautocompleteData("companies", e.target.value).subscribe((res) => {
        this.companylist = res.map((value) => value["company_name"]);
        this.autocomplete_company = true;
      });
    } else {
      this.companylist = [];
    }
  }

  //Typeahead for Location
  searchLocation(e) {
    if (e.target.value != "" && e.target.value.length > 2) {
      this.getautocompleteData("locations", e.target.value).subscribe((res) => {
        this.locationlist = res;
      });
    } else {
      this.locationlist = [];
    }
  }
}
